<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
 <div class="row">
   <div class="col-md-12 margin-top-10">
     <div class="card">
       <div class="card-header wh-header font-size-16px font-weight-normal border-bottom1px-solidgray border-left15px-solidgray padding-top-6px padding-left-15px">
         <div class="row">
           <div class="col-md-3 padding-left-10px">
             <label class="margin-bottom-0px color-backarrow font-size-25px font-weight-bold">Tests</label>             
           </div>
           <div class="col-md-8 padding-right-0px padding-left-10px">
             <div class="row">
               <div class="col-md-4" *ngIf="SelectedTestDetails">
                 <label class="margin-bottom-0px font-size-14">Order Date : {{SelectedTestDetails.OrderDate| date:'dd-MMM-yyyy'}}</label>

               </div>
               <!--<div class="col-md-4" *ngIf="SelectedTestDetails">
                 <label class="margin-bottom-0px font-size-14">Order Time : {{SelectedTestDetails.OrderDate| date: 'hh:mm a'}}</label>

               </div>-->
             </div>
           </div>
         </div>
        
       </div>
     </div>
     <div class="card-body padding-all-0px">
       <div class="row margin-left-0px">
         <div class="col-md-3 padding-right-0px">
           <div class="row margin-left-0px">

             <div class="col-md-11 margin-bottom-10px margin-top-10  padding-right-0px padding-left-0px">
               <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
               <!--<input type="search"  [title]="searchTitle"  (change)="criteriaChange($event)" class="form-control padding-bottom-2px width-230px margin-top-10 margin-bottom-10px" placeholder="Search....">-->
             </div>
           </div>
           <div class="chatsd product-chart-wrapper product-chat-width-100 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">


             <div class="border-bottom row-for-scans2 margin-right-3px" (click)="SelectedTest(l)" *ngFor="let l of pdata">
               <div class="row" (click)="SelectedTest(l)">
                 <div class="col-md-10">
                   <label class="margin-bottom-0px">{{l.TestName}}</label>
                 </div>
                 <div class="col-md-1 padding-right-0px">
                   <div class="float-right" [ngSwitch]="l.OrderTestStatus">


                     <a data-toggle="tooltip" data-placement="bottom" title="Signed">

                       <i *ngSwitchCase="'Signed'"
                          class="fas fa-circle color-checkout nav-link-hand font-size-14 margin-right-5px">
                       </i>
                     </a>
                     <a data-toggle="tooltip" data-placement="bottom" title="Signed (2)">

                       <i *ngSwitchCase="'Signed (2)'"
                          class="fas fa-circle color-checkout nav-link-hand font-size-14 margin-right-5px">
                       </i>
                     </a>
                     <a data-toggle="tooltip" data-placement="bottom" title="Signed (1)">

                       <i *ngSwitchCase="'Signed (1)'"
                          class="fas fa-circle color-signedone nav-link-hand font-size-14 margin-right-5px">
                       </i>
                     </a>
                     <a data-toggle="tooltip" data-placement="bottom" title="Results Entered">

                       <i *ngSwitchCase="'Results Entered'"
                          class="fas fa-circle color-Assign nav-link-hand font-size-14 margin-right-5px">
                       </i>
                     </a>
                     <a data-toggle="tooltip" data-placement="bottom" title="Results Pending">

                       <i *ngSwitchCase="'Results Pending'"
                          class="fas fa-circle gray nav-link-hand font-size-14 margin-right-5px">
                       </i>
                     </a>



                     <a data-toggle="tooltip" data-placement="bottom" title="Pending">
                       <i *ngSwitchDefault
                          class="fas fa-circle color-cyan nav-link-hand font-size-14">
                       </i>
                     </a>
                   </div>
                 </div>

               </div>

               <div class="row" (click)="SelectedTest(l)">
                 <div class="col-md-8 padding-right-0px">
                   <label class="font-size-12px margin-bottom-0px">{{l.LabDepartment}}</label>
                 </div>
                   <div class="col-md-4 padding-left-0px">

                     <label class="font-size-12px margin-bottom-0px">{{l.OrderDate| date:'dd-MMM-yyyy'}}</label>
                   </div>
                
                 <!--<div class="col-md-3">
                   
                   <div class="float-right" [ngSwitch]="l.SpecimenCollectionStatus">


                     <a data-toggle="tooltip" data-placement="bottom" title="Collected">

                       <i *ngSwitchCase="'Collected'"
                          class="fas fa-circle color-checkout nav-link-hand font-size-14 margin-right-5px">
                       </i>
                     </a>






                     <a data-toggle="tooltip" data-placement="bottom" title="Pending">
                       <i *ngSwitchDefault
                          class="fas fa-circle color-cyan nav-link-hand font-size-14">
                       </i>
                     </a>
                   </div>
                 </div>-->
               </div>
             </div>
             </div>
           </div>
         <div class="col-md-9 padding-left-5px" *ngIf="TestDetailsView">
           <div class="row">
             <div class="col-md-12">
               <div class="card">
                 <div class="card-header wh-header border-bottom padding-left-5px padding-right-0px padding-bottom-0px padding-top-0px">
                   <div class="row">
                     <div class="col-md-9">
                       <div class="row  margin-left-0px" *ngIf="SelectedTestDetails">
                         <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                           <h4 class="margin-bottom-0px font-weight-bold color-secondary">{{SelectedTestDetails.TestName}}</h4>
                         </div>
                       </div>
                       <div class="row  margin-left-0px" *ngIf="SelectedTestDetails">
                         <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                           <h4 class="margin-bottom-0px font-weight-normal">{{SelectedTestDetails.LabDepartment}}</h4>
                         </div>
                       </div>
                     </div>
                     <div class="col-md-3">
                       <!--<div class="row">
                         <div class="col-md-12">
                           <h4 class="margin-bottom-0px  font-weight-normal" *ngIf="SelectedTestDetails" >{{SelectedTestDetails.OrderDate| date:'dd-MMM-yyyy'}}</h4>
                         </div>
                       </div>-->
                       <div class="row" *ngIf="SelectedTestDetails">
                         <div class="col-md-8 padding-right-0px" >
                           <h4 class="margin-bottom-0px color-Checkin font-weight-bold">{{SelectedTestDetails.OrderTestStatus}}</h4>

                         </div>
                         <div class="col-md-1 padding-right-0px">
                           <!--<div class="float-right" [ngSwitch]="SelectedTestDetails.OrderTestStatus">


    <a data-toggle="tooltip" data-placement="bottom" title="Signed" class="vertical-align-top">

      <i *ngSwitchCase="'Signed'"
         class="fas fa-circle color-checkout nav-link-hand font-size-14 margin-right-5px">
      </i>
    </a>
    <a data-toggle="tooltip" data-placement="bottom" title="Signed (2)" class="vertical-align-top">

      <i *ngSwitchCase="'Signed (2)'"
         class="fas fa-circle color-checkout nav-link-hand font-size-14 margin-right-5px">
      </i>
    </a>
    <a data-toggle="tooltip" data-placement="bottom" title="Signed (1)" class="vertical-align-top">

      <i *ngSwitchCase="'Signed (1)'"
         class="fas fa-circle color-signedone nav-link-hand font-size-14 margin-right-5px">
      </i>
    </a>
    <a data-toggle="tooltip" data-placement="bottom" title="Results Entered" class="vertical-align-top">

      <i *ngSwitchCase="'Results Entered'"
         class="fas fa-circle color-Assign nav-link-hand font-size-14 margin-right-5px">
      </i>
    </a>
    <a data-toggle="tooltip" data-placement="bottom" title="Results Pending" class="vertical-align-top">

      <i *ngSwitchCase="'Results Pending'"
         class="fas fa-circle gray nav-link-hand font-size-14 margin-right-5px">
      </i>
    </a>



    <a data-toggle="tooltip" data-placement="bottom" title="Pending" class="vertical-align-top">
      <i *ngSwitchDefault
         class="fas fa-circle color-cyan nav-link-hand font-size-14">
      </i>
    </a>
  </div>-->
                           <div class="float-right" *ngIf="SelectedTestDetails.OrderTestStatus=='Signed'">


                             <a data-toggle="tooltip" data-placement="bottom" title="Signed" class="vertical-align-top">

                               <i class="fas fa-circle color-checkout nav-link-hand font-size-14 margin-right-5px">
                               </i>
                             </a>
                           </div>
                           <div class="float-right" *ngIf="SelectedTestDetails.OrderTestStatus=='Signed (2)'">


                             <a data-toggle="tooltip" data-placement="bottom" title="Signed (2)" class="vertical-align-top">

                               <i class="fas fa-circle color-checkout nav-link-hand font-size-14 margin-right-5px">
                               </i>
                             </a>
                           </div>
                           <div class="float-right" *ngIf="SelectedTestDetails.OrderTestStatus=='Signed (1)'">


                             <a data-toggle="tooltip" data-placement="bottom" title="Signed (1)" class="vertical-align-top">

                               <i class="fas fa-circle color-signedone nav-link-hand font-size-14 margin-right-5px">
                               </i>
                             </a>
                           </div>
                           <div class="float-right" *ngIf="SelectedTestDetails.OrderTestStatus=='Results Entered'">


                             <a data-toggle="tooltip" data-placement="bottom" title="Results Entered" class="vertical-align-top">

                               <i class="fas fa-circle color-Assign nav-link-hand font-size-14 margin-right-5px">
                               </i>
                             </a>
                           </div>
                           <div class="float-right" *ngIf="SelectedTestDetails.OrderTestStatus=='Results Pending'">


                             <a data-toggle="tooltip" data-placement="bottom" title="Results Pending" class="vertical-align-top">

                               <i class="fas fa-circle gray nav-link-hand font-size-14 margin-right-5px">
                               </i>
                             </a>
                           </div>
                         </div>
                         </div>
                     </div>
                   </div>
                 </div>
                 <div class="card-body padding-all-0px">
                   <div class="row">
                     <div class="col-md-12 padding-left-0px">
                       <div class="table-component">
                         <div class="table-responsive overflow-x-hidden">


                           <table class="table table-striped margin-left-zero">

                             <thead class="">
                               <tr>
                                 <th class="padding-top-4px padding-bottom-4px padding-left-0px">Date</th>
                                 <th class="td-width-284px padding-top-4px padding-bottom-4px">Observation</th>


                                 <th class="padding-top-4px padding-bottom-4px">Value</th>
                                 <th class="padding-top-4px padding-bottom-4px">Refernce Range</th>
                                 <!--<th></th>-->
                               </tr>
                             </thead>
                             <tbody class="table-body">
                               <tr *ngFor="let l of TestData">


                                 <td class="padding-right-0px padding-top-0px padding-bottom-0px padding-left-0px">{{OrderDate| date:'dd-MMM-yyyy'}}</td>
                                 <td class="padding-right-0px padding-top-0px padding-bottom-0px">{{l.ObservationName}}</td>

                                 <td class="padding-top-0px padding-bottom-0px">{{l.ObservationValue}}</td>
                                 <td class="padding-top-0px padding-bottom-0px">{{l.ReferenceRange}}</td>

                               </tr>

                             </tbody>

                           </table>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </div>
          
         </div>

       </div>
     </div>
   </div>
 </div>

  

  

  


  

